import { injectable } from "inversify";
import CarPeritajeReportEntity from "../../entities/CarPeritajeReportEntity";
import CarPeritajeReportRepository from "../../repositories/CarPeritajeReportRepository";

interface props {
    carPeritajeReportRepository: CarPeritajeReportRepository;
}

@injectable()
export default class GetCarsPeritajeReportUseCase {
    _carPeritajeReportRepository: CarPeritajeReportRepository;

    constructor(_: props) {
        this._carPeritajeReportRepository = _.carPeritajeReportRepository;
    }

    async call(onProgress?: (done: number, total: number) => void): Promise<CarPeritajeReportEntity[]> {
        return await this._carPeritajeReportRepository.getActiveCarsPeritajeReport(onProgress);
    }
}

export const GetCarsPeritajeReportUseCaseName = "GetCarsPeritajeReportUseCaseName";
